import React, { useState } from "react";

import CardPerson from "../../shared/CardPerson";
import { PersonData } from "../../assets/PersonData";

import wallpaper from "../../assets/image/wallpaper.jpg";
import wallpaper2 from "../../assets/image/wallpaper2.jpg";
import wallpaper3 from "../../assets/image/wallpaper3.jpg";

import "./AboutUs.css";
import Carousel from "../../shared/Carousel";

const AboutUs = () => {
  const [active, setActive] = useState(false);
  const [active2, setActive2] = useState(true);
  const [active3, setActive3] = useState(false);

  const moveHandler = () => {
    setActive(true);
    setActive2(false);
    setActive3(false);
  };
  const moveHandler2 = () => {
    setActive(false);
    setActive2(true);
    setActive3(false);
  };
  const moveHandler3 = () => {
    setActive(false);
    setActive2(false);
    setActive3(true);
  };

  return (
    <div className="section-aboutus" id={"about"}>
      <h2 className="section-title">About Us</h2>
      <p className="section-subtitle">
        Your About Us page is vital. It’s often the first stop in any user’s
        journey through a website or blog. It also shouldn’t be their last,
        because first impressions count online just as much as they do in the
        real world. If your visitors aren’t impressed, you can expect them to
        leave without reading your awesome content or completing a conversion
        action (e.g., signing up for your newsletter, making a purchase).
      </p>

      <Carousel slides={PersonData} />

      <div
        className="person-info-wrapper"
        style={
          active3
            ? { marginLeft: "-800px" }
            : active
            ? { marginLeft: "800px" }
            : null
        }
      >
        <CardPerson
          name="Kathy Rosenberg"
          position="Product Mannager"
          email="kathyr@gmail.com"
          image={wallpaper}
        />
        <CardPerson
          name="Alexandra Boyarskaya"
          position="Support Marketing Specialist"
          email="alexandrab@gmail.com"
          image={wallpaper2}
        />
        <CardPerson
          name="Melani Amini"
          position="Photographer"
          email="melania@gmail.com"
          image={wallpaper3}
        />
      </div>
      <div className="dots-wrapper">
        <span
          onClick={moveHandler}
          className={!active ? "dot" : "dot activeDot"}
        ></span>
        <span
          onClick={moveHandler2}
          className={!active2 ? "dot" : "dot activeDot"}
        ></span>
        <span
          onClick={moveHandler3}
          className={!active3 ? "dot" : "dot activeDot"}
        ></span>
      </div>
    </div>
  );
};

export default AboutUs;
